<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="swap-modal" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"> Swap domains </h5>
          </div>
          <div class="modal-body">
            <ul class="list-unstyled">
              <li v-for="(account, index) of swapAccounts" :key="index">
                <div class="row">
                  <div class="col-md-12">
                    <b>Primary Domain: </b> {{ account.primary.domain }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label>Select Addon to swap: </label>
                    <select class="form-control" v-model="account.selectedAddonIndex">
                      <option v-for="(addon, addon_index) of account.addon" :value="addon_index" :key="addon_index">{{ addon.domain }}</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <button type="button" class="btn btn-info btn-md d-inline" @click="swap(index)">
                      Swap
                    </button>
                  </div>
                </div>
                <hr v-if="index < swapAccounts.length-1">
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {db} from "@/firebase/init";
  import swal from "sweetalert2";

  export default {
    name: "swapAccountsModal",
    props: {
      swapAccounts: {
        type: Array,
        required: true
      },
      docID: {
        type: String,
        required: true
      }
    },
    mounted () {
      $(".modal-backdrop").appendTo(".add-addon-domain-modal");
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    methods: {
      async swap (accountIndex) {
        const result = await swal({
          title: "Swap Account",
          text: 'Are you sure to swap domains',
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        })
        if(result.value){
          const addonIndex = this.swapAccounts[accountIndex].selectedAddonIndex
          console.log(this.swapAccounts[accountIndex].primary)
          console.log(this.swapAccounts[accountIndex].addon[addonIndex])
          const oldPrimaryDomainName = this.swapAccounts[accountIndex].primary.domain
          const oldPrimaryFttpDetails = this.swapAccounts[accountIndex].primary.ftp
          const oldPrimaryPhpMyAdminDetails = this.swapAccounts[accountIndex].primary.phpMyAdmin
          const oldPrimaryCloudflareDetails = this.swapAccounts[accountIndex].primary.cloudflare
          const oldPrimaryFlushOpcacheURL = this.swapAccounts[accountIndex].primary.flushOpcacheURL
          const oldPrimaryStaging = this.swapAccounts[accountIndex].primary.staging
          const oldPrimaryStatus = this.swapAccounts[accountIndex].primary.status
          const oldPrimaryStatusCakeId = this.swapAccounts[accountIndex].primary.statusCakeTestId || ''
          const oldPrimaryMonitorId = this.swapAccounts[accountIndex].primary.monitorId || ''
          const oldPrimaryInstallationType = this.swapAccounts[accountIndex].primary.installation_type || ''

          const oldPrimaryAliases = this.swapAccounts[accountIndex].primary.aliases || [];
          const oldPrimaryRedirects = this.swapAccounts[accountIndex].primary.redirects || [];
          const oldPrimaryDiskSpace = this.swapAccounts[accountIndex].primary.diskSpace || [];
          const oldPrimaryTags = this.swapAccounts[accountIndex].primary.tags || [];
          const oldPrimaryUuid = this.swapAccounts[accountIndex].primary.uuid || '';

          this.swapAccounts[accountIndex].primary.domain = this.swapAccounts[accountIndex].addon[addonIndex].domain
          this.swapAccounts[accountIndex].primary.ftp  = this.swapAccounts[accountIndex].addon[addonIndex].ftp
          this.swapAccounts[accountIndex].primary.phpMyAdmin  = this.swapAccounts[accountIndex].addon[addonIndex].phpMyAdmin
          this.swapAccounts[accountIndex].primary.cloudflare  = this.swapAccounts[accountIndex].addon[addonIndex].cloudflare
          this.swapAccounts[accountIndex].primary.flushOpcacheURL  = this.swapAccounts[accountIndex].addon[addonIndex].flushOpcacheURL
          this.swapAccounts[accountIndex].primary.staging  = this.swapAccounts[accountIndex].addon[addonIndex].staging
          this.swapAccounts[accountIndex].primary.status  = this.swapAccounts[accountIndex].addon[addonIndex].status
          this.swapAccounts[accountIndex].primary.statusCakeTestId  = this.swapAccounts[accountIndex].addon[addonIndex].statusCakeTestId || ''
          this.swapAccounts[accountIndex].primary.monitorId  = this.swapAccounts[accountIndex].addon[addonIndex].monitorId || ''
          this.swapAccounts[accountIndex].primary.installation_type  = this.swapAccounts[accountIndex].addon[addonIndex].installation_type || ''
          this.swapAccounts[accountIndex].primary.aliases  = this.swapAccounts[accountIndex].addon[addonIndex].aliases || [];
          this.swapAccounts[accountIndex].primary.redirects  = this.swapAccounts[accountIndex].addon[addonIndex].redirects || [];
          this.swapAccounts[accountIndex].primary.diskSpace  = this.swapAccounts[accountIndex].addon[addonIndex].diskSpace || [];
          this.swapAccounts[accountIndex].primary.tags  = this.swapAccounts[accountIndex].addon[addonIndex].tags || [];
          this.swapAccounts[accountIndex].primary.uuid  = this.swapAccounts[accountIndex].addon[addonIndex].uuid || '';

          this.swapAccounts[accountIndex].addon[addonIndex].domain = oldPrimaryDomainName
          this.swapAccounts[accountIndex].addon[addonIndex].ftp = oldPrimaryFttpDetails
          this.swapAccounts[accountIndex].addon[addonIndex].phpMyAdmin = oldPrimaryPhpMyAdminDetails
          this.swapAccounts[accountIndex].addon[addonIndex].cloudflare = oldPrimaryCloudflareDetails
          this.swapAccounts[accountIndex].addon[addonIndex].flushOpcacheURL = oldPrimaryFlushOpcacheURL
          this.swapAccounts[accountIndex].addon[addonIndex].staging = oldPrimaryStaging
          this.swapAccounts[accountIndex].addon[addonIndex].status = oldPrimaryStatus
          this.swapAccounts[accountIndex].addon[addonIndex].statusCakeTestId = oldPrimaryStatusCakeId
          this.swapAccounts[accountIndex].addon[addonIndex].monitorId = oldPrimaryMonitorId
          this.swapAccounts[accountIndex].addon[addonIndex].installation_type = oldPrimaryInstallationType
          this.swapAccounts[accountIndex].addon[addonIndex].aliases = oldPrimaryAliases
          this.swapAccounts[accountIndex].addon[addonIndex].redirects = oldPrimaryRedirects
          this.swapAccounts[accountIndex].addon[addonIndex].diskSpace = oldPrimaryDiskSpace
          this.swapAccounts[accountIndex].addon[addonIndex].tags = oldPrimaryTags
          this.swapAccounts[accountIndex].addon[addonIndex].uuid = oldPrimaryUuid
          console.log(this.swapAccounts)
          this.swapAccounts[accountIndex].selectedAddonIndex = null
          $('#swap-modal').modal('toggle');

          await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: this.swapAccounts , beforePayload: false, action: 'Swap Accounts' })

          await db.collection('hostingAccounts').doc(this.docID).update({
            accounts: this.swapAccounts,
            updatedAt: new Date().toISOString()
          });
          await this.addLog({
            primaryPlan: this.swapAccounts[accountIndex].primary.domain,
            uid: this.docID,
            message: `User has swapped Primary account ${oldPrimaryDomainName} with addon ${this.swapAccounts[accountIndex].primary.domain}`,
            level: "info"
          });

          swal('Success!', 'Domains swapped', 'success');
        }
      }
    }
  }
</script>

<style scoped>

</style>
